import { render, staticRenderFns } from "./ManageValues.vue?vue&type=template&id=c67b2f7a&"
import script from "./ManageValues.vue?vue&type=script&lang=js&"
export * from "./ManageValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports